import { FAQPageModel } from './model';
import { action } from 'mobx';
import { RedirectFunction, RouterState } from 'react-router';
import { PrismicController } from '../../prismic/controller';
import { BugsnagController } from '../../bugsnag/controller';
import { EnvModel } from '../../env/model';
import { UIController } from '../../ui/controller';

export class FAQPageController {

  constructor(
    private model: FAQPageModel,
    private prismic: PrismicController,
    private bugsnag: BugsnagController,
    private env: EnvModel,
    private ui: UIController
  ) {}

  @action
  onEnter = async (nextState: RouterState, replace: RedirectFunction) => {
    this.model.loading = true;
    const document = 'faq';

    this.ui.setBreadcrumbs([{
      path: '/faq',
      label: 'FAQ'
    }]);

    await this.ui.setSEO(nextState.location.pathname);

    try {
      const [{ data }] = await Promise.all([
        this.prismic.getSingle(document),
        this.env.ready
      ]);

      // RichText
      this.model.page_title = data.page_title;

      // Image
      this.model.cover_image = data.cover_image.url;

      this.model.sections = data.body;

    } catch (e) {
      this.bugsnag.notifyException(e);
    } finally {
      this.model.loading = false;
    }

    return;
  };
}